import { Command } from 'pos/common';
import { DeliveryNoteDTO, Permission, DocumentType } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { printDocument } from 'pos/modules/helpers/document-printing';
import { PrintFacade } from 'pos/facades';
import * as DeliveryNoteStore from './DeliveryNoteStore';

declare global {
	interface CommandType {
		printDeliveryNote: (deliveryNote: DeliveryNoteDTO) => Promise<Result>
	}
}

Command.register('printDeliveryNote', Preconditions.and(Preconditions.ensure(Permission.DeliveryNote_Print), Preconditions.ensureIsNotLite), async (deliveryNote: DeliveryNoteDTO): Promise<Result> => {

	const options = await PrintFacade.getPrintOptions(DocumentType.DeliveryNote);
	return printDocument({
		getOptions: () => options,
		print: params => DeliveryNoteStore.printDeliveryNote(deliveryNote.Id, params)
	});
});
